import React, { useState, useCallback, useEffect } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import './ResidentialPlans.scss'
import Table from '@mui/material/Table'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import CheckBox from '@mui/material/Checkbox'
import Switch from '@mui/material/Switch'
import Button from '@mui/material/Button'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import { BsCheckCircle } from 'react-icons/bs'
import TablePagination from '@mui/material/TablePagination'
import { useCMSContext } from '../../CMSContext'
import ResidentialPlansActions from './ResidentialPlansActions'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import ResidentialPlansDetailDialog from '../../../Shared/ResidentialPlansDetailDialog/ResidentialPlansDetailDialog'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import { parseDate } from '../../../../../resources/Utils'
import { UserTypeEnum } from '../../../../Constants/iarMemberEnum'
import ResidentialPlanTypeSelect from './components/ResidentialPlanTypeSelect'

function ResidentialPlans() {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const cmsContext = useCMSContext()
  const { fireDepartment, iarMember, isReadOnlyMember } = cmsContext.state
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [rowState, setRowState] = useState({})
  const [detailDialog, setDetailDialog] = useState({ open: false })
  const [approvesDialog, setApprovesDialog] = useState({ open: false })
  const [page, setPage] = useState(0)
  const [paginationIds, setPaginationIds] = useState({ first: '', last: '' })
  const [pageId, setPageId] = useState([])
  const [residentialplansEntity, setResidentialPlansEntity] = useState({ residentialPlans: [] })
  const [allSelected, setAllSelected] = useState(false)
  const [showApproveColumn, setShowApproveColumn] = useState(false)
  const [activeSwitch, setActiveSwitch] = useState(false)
  const [automatic, setAutomatic] = useState(false)
  const [automaticUn, setAutomaticUn] = useState(false)
  const [filterPlans, setFilterPlans] = useState({ first: 0, last: 0 })

  Interceptor.interceptor(errorSnackBarActions)

  useEffect(() => {
    if (fireDepartment !== null && fireDepartment !== undefined) {
      setPaginationIds({ first: '0', last: '0' })
      async function fetchResidentialPlans() {
        const response = await ResidentialPlansActions.getResidentialPlans(
          fireDepartment.identifier,
          '0',
          filterPlans.last
        )
        if (!response.residentialPlans) {
          setResidentialPlansEntity({
            ...residentialplansEntity,
            residentialPlans: [],
            total: 0
          })
          setPage(0)
          return
        }

        let residentialPlansArray = response.residentialPlans

        setPaginationIds({
          first:
            residentialPlansArray.length > 0
              ? residentialPlansArray[residentialPlansArray.length - 1].date
              : '',
          last:
            residentialPlansArray.length > 0
              ? residentialPlansArray[residentialPlansArray.length - 1].date
              : ''
        })
        response.residentialPlans = residentialPlansArray
        setResidentialPlansEntity(response)
      }
      fetchResidentialPlans()
    }
  }, [fireDepartment, filterPlans])

  useEffect(() => {
    if (fireDepartment !== null && fireDepartment !== undefined) {
      async function fetchDepartmentsetting() {
        const response = await ResidentialPlansActions.getAutomaticApproveResidentialPlans(
          fireDepartment.fireDepartmentId,
          iarMember.fullName
        )
        if (response && response.automaticResidentialPlansApprove) {
          setActiveSwitch(true)
        }
      }
      fetchDepartmentsetting()
    }
  }, [fireDepartment])

  async function fetchResidentialPlans(id, newPage) {
    const response = await ResidentialPlansActions.getResidentialPlans(
      fireDepartment.identifier,
      id,
      filterPlans.last
    )
    if (response) {
      setPaginationIds({
        first: paginationIds.last,
        last: response.residentialPlans[response.residentialPlans.length - 1].date
      })
      setPage(newPage)
      setResidentialPlansEntity(response)
    }
  }

  const handlerFilterResidentialPlans = (residentialPlanType) => {
    setFilterPlans({
      first: filterPlans.last,
      last: residentialPlanType
    })
    setPage(0)
  }

  const handleChangePage = useCallback(
    (event, newPage) => {
      const pageIds = pageId
      if (newPage > page) {
        pageIds.push({ page: newPage, id: paginationIds.last })
        setPageId(pageIds)
      }
      const id = newPage === 0 ? '0' : pageId.find((i) => i.page === newPage).id

      fetchResidentialPlans(id, newPage).then((r) => r)
    },
    [page, pageId, paginationIds, fetchResidentialPlans]
  )

  const openDetailDialog = (item) => {
    setRowState(item)
    setDetailDialog({ open: true })
  }

  const updateApprovesDialog = (value) => {
    setApprovesDialog({ open: value })
  }

  const closePostNewsDialog = () => {
    setRowState({})
    setDetailDialog({ open: false })
  }

  const setApproveColumn = (value) => {
    setShowApproveColumn(value)
  }

  const automaticApproveRecords = useCallback(() => {
    async function fetchAutomaticDepartmentSettingsApproved() {
      if (iarMember && fireDepartment) {
        await ResidentialPlansActions.automaticApproveDepartmentSettings(
          fireDepartment.fireDepartmentId,
          fireDepartment.identifier,
          iarMember.fullName,
          true
        )
        const responseApprove = await ResidentialPlansActions.automaticApproveResidentialPlans(
          fireDepartment.fireDepartmentId,
          fireDepartment.identifier,
          iarMember.fullName,
          true
        )
        if (responseApprove) {
          handleChangePage(null, page)
        }
      }
      setAutomatic(false)
    }

    fetchAutomaticDepartmentSettingsApproved()
  }, [page, handleChangePage, fireDepartment, iarMember])

  const automaticUnapproveRecords = useCallback(() => {
    async function fetchAutomaticDepartmentSettingsUnapproved() {
      if (iarMember && fireDepartment) {
        await ResidentialPlansActions.automaticApproveDepartmentSettings(
          fireDepartment.fireDepartmentId,
          fireDepartment.identifier,
          iarMember.fullName,
          false
        )
        setAutomaticUn(false)
        const responseApprove = await ResidentialPlansActions.automaticApproveResidentialPlans(
          fireDepartment.fireDepartmentId,
          fireDepartment.identifier,
          iarMember.fullName,
          false
        )
        if (responseApprove) {
          handleChangePage(null, page)
        }
      }
    }

    fetchAutomaticDepartmentSettingsUnapproved()
  }, [page, handleChangePage, fireDepartment, iarMember])

  const approveRecords = useCallback(() => {
    async function fetchResidentialPlansApproved() {
      var rpIds = residentialplansEntity.residentialPlans
        .map((el) => {
          if (el.isSelected) {
            return el._id
          } else {
            return null
          }
        })
        .filter((el) => el !== undefined)
      const response = await ResidentialPlansActions.approveResidentialPlans(
        rpIds,
        iarMember.fullName
      )
      setApprovesDialog({ open: false })
      setApproveColumn(false)
      if (allSelected) {
        setAllSelected(false)
      }
      if (response) {
        handleChangePage(null, page)
      }
    }
    fetchResidentialPlansApproved()
  }, [residentialplansEntity, page, handleChangePage])

  const handleRowClick = useCallback(
    (event, id) => {
      var residentialPlansSelected = residentialplansEntity.residentialPlans.find(
        (el) => el._id === id
      )
      var residentialsArray = residentialplansEntity.residentialPlans
      var indexOfSelected = residentialsArray.findIndex((el) => el._id === id)
      residentialPlansSelected.isSelected = !residentialPlansSelected.isSelected
      residentialsArray[indexOfSelected] = residentialPlansSelected
      setResidentialPlansEntity({
        ...residentialplansEntity,
        residentialPlans: residentialsArray
      })
    },
    [residentialplansEntity]
  )

  const onSelectAllClick = useCallback(() => {
    var arrayResidentialPlans = residentialplansEntity.residentialPlans
    // eslint-disable-next-line array-callback-return
    arrayResidentialPlans.map((el) => {
      el.isSelected = !allSelected
    })
    setResidentialPlansEntity({
      ...residentialplansEntity,
      residentialPlans: arrayResidentialPlans
    })
    setAllSelected(!allSelected)
  }, [residentialplansEntity, allSelected])

  const cancelProccess = useCallback(() => {
    var arrayResidentialPlans = residentialplansEntity.residentialPlans
    // eslint-disable-next-line array-callback-return
    arrayResidentialPlans.map((el) => {
      el.isSelected = false
    })
    setResidentialPlansEntity({
      ...residentialplansEntity,
      residentialPlans: arrayResidentialPlans
    })
    if (allSelected) {
      setAllSelected(false)
    }
    setShowApproveColumn(false)
  })

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleAutomaticChange = useCallback((event) => {
    const value = event.target.checked
    setAutomatic(value)
    setActiveSwitch(value)
    if (value === false) {
      setAutomaticUn(true)
    }
  }, [])

  const handleClickWatchDetailsPermission = (displayDetailsFunction) => {
    iarMember.allowDisplayResidentialPlanDetails ||
    iarMember.userType === UserTypeEnum.Administrator
      ? displayDetailsFunction()
      : errorSnackBarActions.setOpen(
          true,
          "You don't have permissions to see residential plan details",
          'info'
        )
  }

  const cancelAutomatic = useCallback((value) => {
    setAutomatic(value)
    setActiveSwitch(value)
  }, [])

  const tableToolTip = (
    <div
      style={{
        padding: '4px 10px',
        fontSize: 14
      }}
    >
      View details
    </div>
  )

  return (
    <div className="residentialplans">
      {(rowState && rowState._id) || (detailDialog.open && !rowState._id) ? (
        <ResidentialPlansDetailDialog
          id={rowState._id}
          title="Detail"
          open={detailDialog.open}
          onCancel={closePostNewsDialog}
          onClose={closePostNewsDialog}
          page={page}
          pageChange={handleChangePage}
          setResidentialPlansEntity={setResidentialPlansEntity}
          residentialplans={residentialplansEntity.residentialPlans}
        />
      ) : (
        <></>
      )}
      <IARDialog
        open={approvesDialog.open}
        title="Confirm"
        content={
          <div className="dialogContent">
            <div>Do you want to approve this selected Residential Plans?</div>
          </div>
        }
        onOk={approveRecords}
        onCancel={() => updateApprovesDialog(false)}
      />
      <IARDialog
        open={automatic}
        title="Confirm"
        content={
          <div className="dialogContent">
            <div>Do you want to approve all the residential plans automatically?</div>
          </div>
        }
        onOk={() => automaticApproveRecords()}
        onCancel={() => cancelAutomatic(false)}
      />
      <IARDialog
        open={automaticUn}
        title="Confirm"
        content={
          <div className="dialogContent">
            <div>Do you want to remove the residential plans automatic approve functionality?</div>
          </div>
        }
        onOk={() => automaticUnapproveRecords()}
        onCancel={() => cancelAutomatic(false)}
      />
      <div className="page-header">
        <span>Residential Plans</span>
      </div>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={12}>
            <div className="page-description">
              Here you can see all of the residential property information that has been submitted
              to your agency by your community members. Click on any row to see details. These
              details appear in your IaR maps once they have been approved. You can select to have
              then be automatically approved when submitted, or you can choose to manually approve
              them. If you select manual approving, please be sure to check back here regularly to
              approve new ones.
            </div>
          </Grid>
          <ResidentialPlanTypeSelect
            handlerFilterResidentialPlans={handlerFilterResidentialPlans}
          />
          {iarMember?.isResidentialPlansApproved && (
            <Grid size={12} className="approve-button-container">
              {!showApproveColumn && iarMember.allowDisplayResidentialPlanDetails && (
                <Grid>
                  <div>
                    <span>Approve automatically</span>
                    <Switch
                      disabled={isReadOnlyMember}
                      color={isReadOnlyMember ? 'default' : 'primary'}
                      name="activeSwitch"
                      checked={activeSwitch}
                      onChange={handleAutomaticChange}
                    />
                  </div>
                </Grid>
              )}
              {!showApproveColumn &&
                !residentialplansEntity.residentialPlans.every((e) => e.approved) &&
                !activeSwitch &&
                iarMember.allowDisplayResidentialPlanDetails && (
                  <Grid>
                    <Button
                      disabled={isReadOnlyMember}
                      style={isReadOnlyMember ? { color: 'rgba(0, 0, 0, 0.26)' } : {}}
                      variant="contained"
                      id="showApproveButton"
                      size="medium"
                      className="show-approve-button"
                      onClick={() => setApproveColumn(true)}
                    >
                      Approve manually
                    </Button>
                  </Grid>
                )}
              {showApproveColumn && (
                <Grid>
                  <Button
                    variant="contained"
                    id="showApproveButton"
                    size="medium"
                    className="hide-approve-button"
                    onClick={() => cancelProccess()}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
              {showApproveColumn &&
              residentialplansEntity.residentialPlans.findIndex((el) => el.isSelected) > -1 ? (
                <Grid>
                  <Button
                    variant="contained"
                    id="showApproveButton"
                    size="medium"
                    className="approve-button"
                    onClick={() => updateApprovesDialog(true)}
                  >
                    Approve residential plans
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          )}

          <Grid size={12} className="table-container">
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow className="table-header">
                    {showApproveColumn && (
                      <TableCell align="center">
                        {!residentialplansEntity.residentialPlans.every((e) => e.approved) ? (
                          <CheckBox
                            size="small"
                            style={{
                              transform: 'scale(0.8)',
                              color: '#1C9CD5'
                            }}
                            onChange={onSelectAllClick}
                            inputProps={{ 'aria-label': '' }}
                            checked={allSelected}
                          />
                        ) : (
                          <></>
                        )}
                      </TableCell>
                    )}
                    <TableCell>Created By</TableCell>
                    <TableCell align="center">Address</TableCell>
                    <TableCell>Last update</TableCell>
                    <TableCell align="center">Approved</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {residentialplansEntity.residentialPlans &&
                    residentialplansEntity.residentialPlans.length > 0 &&
                    residentialplansEntity.residentialPlans.map((row) => (
                      <Tooltip className="table-tooltip" arrow title={tableToolTip} key={row._id}>
                        <TableRow
                          hover
                          className="table-row"
                          selected={!row.approved && row.isSelected}
                        >
                          {showApproveColumn && (
                            <TableCell align="center" component="th" scope="row">
                              {!row.approved ? (
                                <CheckBox
                                  size="small"
                                  style={{
                                    transform: 'scale(0.8)',
                                    color: '#1C9CD5'
                                  }}
                                  checked={row.isSelected ? true : false}
                                  onChange={(event) => handleRowClick(event, row._id)}
                                />
                              ) : (
                                <></>
                              )}
                            </TableCell>
                          )}
                          <TableCell
                            onClick={() =>
                              handleClickWatchDetailsPermission(() => openDetailDialog(row))
                            }
                            component="th"
                            scope="row"
                          >
                            {residentialplansEntity.communityMembers[row.communityMemberId]
                              ? residentialplansEntity.communityMembers[row.communityMemberId]
                                  .fullName
                              : 'User not found...'}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleClickWatchDetailsPermission(() => openDetailDialog(row))
                            }
                            align="center"
                          >
                            <>
                              {(() => {
                                switch (row.propertyTypeId) {
                                  case 1:
                                    return (
                                      <>{`${row.propertyLocation.streetNumber},
                                         ${row.propertyLocation.streetName},
                                         ${row.propertyLocation.city},
                                         ${row.propertyLocation.state},
                                         ${row.propertyLocation.country}`}</>
                                    )
                                  case 2:
                                    return (
                                      <>{`${row.propertyLocation.streetNumber},
                                         ${row.propertyLocation.streetName},
                                         ${
                                           row.propertyLocation.unitNumber !== null &&
                                           row.propertyLocation.unitNumber !== ''
                                             ? `Unit: ${row.propertyLocation.unitNumber},`
                                             : ''
                                         }
                                         ${row.propertyLocation.city}, ${
                                           row.propertyLocation.state
                                         }, ${row.propertyLocation.country}`}</>
                                    )
                                  case 3:
                                    return (
                                      <>{`${row.propertyLocation.streetNumber},
                                         ${row.propertyLocation.streetName},
                                         ${row.propertyLocation.city},
                                         ${row.propertyLocation.state},
                                         ${row.propertyLocation.country}`}</>
                                    )
                                  case 4:
                                    return (
                                      <>{`${row.propertyLocation.streetNumber},
                                         ${row.propertyLocation.streetName},
                                         ${
                                           row.propertyLocation.apartmentNumber !== null &&
                                           row.propertyLocation.apartmentNumber !== ''
                                             ? `Apartment: ${row.propertyLocation.apartmentNumber},`
                                             : ''
                                         }
                                         ${
                                           row.propertyLocation.floor !== null &&
                                           row.propertyLocation.floor !== ''
                                             ? `Floor: ${row.propertyLocation.floor},`
                                             : ''
                                         }
                                         ${row.propertyLocation.city},
                                         ${row.propertyLocation.state},
                                         ${row.propertyLocation.country}`}</>
                                    )
                                  case 5:
                                    return (
                                      <>{`${row.propertyLocation.streetNumber},
                                         ${row.propertyLocation.streetName},
                                         ${row.propertyLocation.city},
                                         ${row.propertyLocation.state},
                                         ${row.propertyLocation.country}`}</>
                                    )
                                  case 6:
                                    return (
                                      <span>
                                        {row.propertyTypeOther !== null &&
                                        row.propertyTypeOther !== ''
                                          ? row.propertyTypeOther
                                          : ''}
                                      </span>
                                    )
                                  default:
                                    return ''
                                }
                              })()}
                            </>
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleClickWatchDetailsPermission(() => openDetailDialog(row))
                            }
                          >
                            {parseDate(row.localUpdateDate || row.updatedDate, 'HH:mm MMM dd, y')}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleClickWatchDetailsPermission(() => openDetailDialog(row))
                            }
                            align="center"
                          >
                            {row.approved ? (
                              <span style={{ color: '#1c9cd5' }}>
                                <BsCheckCircle size={20} />
                              </span>
                            ) : (
                              ''
                            )}
                          </TableCell>
                        </TableRow>
                      </Tooltip>
                    ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      count={
                        residentialplansEntity
                          ? residentialplansEntity.total
                            ? residentialplansEntity.total
                            : 0
                          : 0
                      }
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default ResidentialPlans
